import { render, staticRenderFns } from "./ScanDifference.vue?vue&type=template&id=3776433a&scoped=true"
import script from "./ScanDifference.vue?vue&type=script&lang=ts"
export * from "./ScanDifference.vue?vue&type=script&lang=ts"
import style0 from "./ScanDifference.vue?vue&type=style&index=0&id=3776433a&scoped=true&lang=scss"
import style1 from "./ScanDifference.vue?vue&type=style&index=1&id=3776433a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3776433a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3776433a')) {
      api.createRecord('3776433a', component.options)
    } else {
      api.reload('3776433a', component.options)
    }
    module.hot.accept("./ScanDifference.vue?vue&type=template&id=3776433a&scoped=true", function () {
      api.rerender('3776433a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stock/ScanDifference.vue"
export default component.exports